import { render, staticRenderFns } from "./ExamMasterFee.vue?vue&type=template&id=5306c6ee&scoped=true&"
import script from "./ExamMasterFee.vue?vue&type=script&lang=js&"
export * from "./ExamMasterFee.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5306c6ee",
  null
  
)

export default component.exports